import { axiosReq } from "@/lib/axios"
import { EventFormType } from "../components/EventForm"
import { useMutation, useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

export type SocialMediaPost = {
  platform: string;
  text: string;
  image_video_recommendations: string;
  hashtags: string[];
  cta: string;
  date_of_posting: string;
  time_of_posting: string;
};

export type PlaygroundResponseType = {
  data: {
    event_id: number,
    event_name: string,
    event_description: string | null,
    event_type: string,
    activity: string,
    start_date: string,
    end_date: string,
    posts: SocialMediaPost[]
  }
}

export const useGetResults = () => {
  const request = async (data: EventFormType): Promise<PlaygroundResponseType> => {
    const eventDetails = {
      event_name: data.eventName,
      event_description: data.description,
      event_type: data.eventType,
      start_date: format(data.startDate, 'yyyy-MM-dd'),
      end_date: format(data.endDate, 'yyyy-MM-dd'),
      frequency: data.frequency,
      activity: data.activity
    };
    const response = await axiosReq.post('/api/approval/post-playground/', eventDetails);
    return response.data;
  }

  const { mutate: getResults, status, data: results } = useMutation({
    mutationFn: request
  })
  return { getResults, results, status }
}

export type HistoryResponseType = {
  data: {
    event_id: number,
    event_name: string,
    event_description: string | null,
    event_type: string,
    activity: string,
    start_date: string,
    end_date: string,
    posts: SocialMediaPost[]
  }[]
}


export const useGetPlaygroundHistory = () => {
  const request = async():Promise<HistoryResponseType> => {
    const response = await axiosReq.get('/api/approval/historic-playground/')
    return response.data
  }

  const { data:playHistoryData, isLoading } = useQuery({
    queryKey: ["play-history"],
    queryFn: request
  })

  return {playHistoryData, isLoading}
}

export type EventAttributesType = {
  id: number,
  event_id: number,
  smart_goals: string,
  seasonal_cultural: string,
  content_performance: string,
  event_hashtags: string,
  event_keywords: string,
  event_colors: string,
  event_tone: string,
  event_assets_description: string,
  event_name: string,
}

export type BrandAttributesType = {
  id: number,
  event_name: string,
  event_id: number,
  event_performance: string,
  keywords: string,
  content_pillars: string,
  hashtags: string,
  hooks: string

}

export const useGetSocialAttributes = (eventId: number) => {
  const request = async (eventId: number): Promise<{
    message: string,
    attribute_events: EventAttributesType,
    attributes_brands: BrandAttributesType
  }> => {
    const response = await axiosReq.get(`/api/approval/get-attribute-brand-event/?event_id=${eventId}`)
    return response.data
  }

  const { data: postAttributes, isLoading } = useQuery({
    queryKey: ["social-attr", eventId],
    queryFn: () => request(eventId),
    enabled: eventId !== 0
  })

  return { postAttributes, isLoading }
}


